<template>
  <div class="custom-user-select">
    <div
      v-b-popover.html="{
        container: '#app',
        trigger: 'hover blur',
        content: defaultUserTooltip,
        placement: 'top',
      }"
      :class="{ 'active-user': selectedUsers.includes('default') }"
      class="custom-user-select__user"
      @click="clickHandler($event)"
    >
      <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="17" cy="17" r="17" fill="#BFC9E0" />
        <path
          d="M19.7779 18.1574L20.3334 18.9888L20.3334 18.9888L19.7779 18.1574ZM17.9755 9.09608L18.1705 8.11529L17.9755 9.09608ZM15.0866 9.3806L15.4693 10.3045L15.4693 10.3045L15.0866 9.3806ZM12.8427 11.2222L12.0112 10.6666L12.0112 10.6666L12.8427 11.2222ZM11 14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14H11ZM16 22C16 22.5523 16.4477 23 17 23C17.5523 23 18 22.5523 18 22H16ZM18.7335 18.6899L19.2825 19.5257L19.2825 19.5257L18.7335 18.6899ZM20.3334 18.9888C21.3201 18.3295 22.0892 17.3925 22.5433 16.2961L20.6955 15.5307C20.3928 16.2616 19.8801 16.8864 19.2223 17.3259L20.3334 18.9888ZM22.5433 16.2961C22.9974 15.1997 23.1162 13.9933 22.8847 12.8295L20.9231 13.2196C21.0775 13.9956 20.9983 14.7998 20.6955 15.5307L22.5433 16.2961ZM22.8847 12.8295C22.6532 11.6656 22.0818 10.5965 21.2426 9.75736L19.8284 11.1716C20.3878 11.731 20.7688 12.4437 20.9231 13.2196L22.8847 12.8295ZM21.2426 9.75736C20.4035 8.91825 19.3344 8.3468 18.1705 8.11529L17.7804 10.0769C18.5563 10.2312 19.269 10.6122 19.8284 11.1716L21.2426 9.75736ZM18.1705 8.11529C17.0067 7.88378 15.8003 8.0026 14.7039 8.45672L15.4693 10.3045C16.2002 10.0017 17.0044 9.92252 17.7804 10.0769L18.1705 8.11529ZM14.7039 8.45672C13.6075 8.91085 12.6705 9.67989 12.0112 10.6666L13.6741 11.7777C14.1136 11.1199 14.7384 10.6072 15.4693 10.3045L14.7039 8.45672ZM12.0112 10.6666C11.3519 11.6533 11 12.8133 11 14H13C13 13.2089 13.2346 12.4355 13.6741 11.7777L12.0112 10.6666ZM18 22C18 21.0628 18.1219 20.6518 18.2669 20.4045C18.4164 20.1494 18.6654 19.931 19.2825 19.5257L18.1846 17.854C17.5682 18.2588 16.9504 18.6955 16.5415 19.393C16.1281 20.0982 16 20.9372 16 22H18ZM19.2825 19.5257C19.3362 19.4904 19.4268 19.4484 19.6442 19.351C19.8213 19.2716 20.0893 19.1519 20.3334 18.9888L19.2223 17.3259C19.1387 17.3817 19.0212 17.4385 18.8265 17.5258C18.672 17.595 18.4044 17.7097 18.1846 17.854L19.2825 19.5257Z"
          fill="white"
        />
        <circle cx="17" cy="26" r="1" fill="white" />
      </svg>
    </div>
    <div
      v-for="(user, userIndex) in users"
      :key="user.id"
      v-b-popover.html="{
        container: '#app',
        trigger: 'hover blur',
        content: user.name,
        placement: 'top',
      }"
      :style="{
        transform: `translateX(-${userIndex + 1}0px)`,
      }"
      class="custom-user-select__user"
      :class="{ 'active-user': selectedUsers.includes(user.id) }"
      @click="clickHandler($event, user.id)"
    >
      <img :src="user.avatar || defaultUserAvatar" :alt="user.id" @error="replaceImageOnErrorLoad" />
    </div>
  </div>
</template>

<script>
import defaultUserAvatar from "@/assets/images/borderless_userpic.svg";

export default {
  name: "user-select",
  props: {
    users: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: () => false,
    },
    defaultUserTooltip: {
      type: String,
      default: () => "Пользователь не выбран",
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      defaultUserAvatar,
      selectedUsers: [...this.value],
    };
  },
  watch: {
    value: {
      deep: true,
      handler(value) {
        if (!value.length) {
          this.resetUsers();
        }
      },
    },
  },
  methods: {
    resetUsers() {
      const users = document.querySelectorAll(".active-user");
      users.forEach((user) => {
        user.classList.remove("active-user");
      });
    },
    clickHandler(event, user = "default") {
      if (!this.multiple) {
        this.resetUsers();
        event.currentTarget.classList.add("active-user");
        this.selectedUsers = [];
        this.selectedUsers.push(user);
        this.$emit("input", this.selectedUsers);
        return;
      }

      event.currentTarget.classList.toggle("active-user");
      if (this.selectedUsers.includes(user)) {
        const userIndex = this.selectedUsers.findIndex((u) => u === user);
        this.selectedUsers.splice(userIndex, 1);
      } else {
        this.selectedUsers.push(user);
      }
      this.$emit("input", this.selectedUsers);
    },
    replaceImageOnErrorLoad(e) {
      e.target.src = defaultUserAvatar;
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-user-select {
  display: flex;
  align-items: center;

  &__user {
    border: 2px solid #fff;
    border-radius: 50%;

    & > img {
      height: 34px;
      width: 34px;
      border-radius: 100%;
      object-fit: cover;
    }
  }
}
.active-user {
  box-shadow: 0 0 1px transparent;
  border-color: #ff238d;
}
</style>
